import axios from 'axios';
import { store } from '../redux/store';

const API_URL = import.meta.env.VITE_API_URL
console.log(API_URL);

const api = axios.create({
    baseURL: API_URL,
    timeout: 120000,
    headers: {
        'Accept': 'application/json, text/plain',
        'Access-Control-Allow-Origin': '*',
    },
});


// Add a request interceptor to add the Authorization header
api.interceptors.request.use(
    (config) => {
        // Retrieve the token from storage (e.g., localStorage)
        const token = localStorage.getItem('authToken');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export default api;